import React, { useEffect, useCallback, useRef, useState } from "react";
import { Container, Paper } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import { API_KEY } from "../config";

import * as yup from "yup";
import { useFetch } from "../hooks";

import { Body1, H6 } from "../components/tipografia";
import { EntradaForm } from "../components";
import { ToastErro } from "../utils/utils";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

// Schema de validacao dos daddos
const schemaValidator = yup.object().shape({
  email: yup.string().email().required(),
});
const schemaMessageError = {
  email: "* E-mail inválido",
};
const schema = [
  {
    type: "email",
    icon: "Email",
    name: "email",
    placeholder: " Informe o seu email",
    label: "* E-mail",
  },
];

export default function EsqueciASenha() {
  // Para referenciar o captcha invisivel
  const recaptchaRef = useRef();
  // Estado que controla a atividade do token
  const [token, setToken] = useState(null);
  return (
    <Container>
      <H6>Esqueceu a senha ?</H6>
      <Body1 component="p" textAlign="center">
        Informe abaixo o seu e-mail para que possamos enviar instruções de como
        recuperar a senha
      </Body1>
      <FormEsqueciSenha
        token={token}
        setToken={setToken}
        recaptchaRef={recaptchaRef}
      />
      <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={API_KEY} />
    </Container>
  );
}

const FormEsqueciSenha = ({ recaptchaRef, token, setToken }) => {
  const { wait, error, setFetch, data } = useFetch(
    "/esqueci_a_senha",
    "POST",
    "normal"
  );
  useEffect(() => {
    if (error) ToastErro(error);
  }, [error]);

  const history = useHistory();

  // Funcao para enviar os dados para autenticacao
  const onSubmit = useCallback(
    async (val) => {
      let TOKEN = recaptchaRef.current.getValue();
      if (!token) {
        TOKEN = await recaptchaRef.current.executeAsync();
        setToken(TOKEN);
      } else {
        await recaptchaRef.current.reset();
        TOKEN = await recaptchaRef.current.executeAsync();
      }

      const inDados = { ...val, captcha: TOKEN };
      // Enviar para o backend
      setFetch(inDados);
    },
    [token, recaptchaRef, setFetch, setToken]
  );
  useEffect(() => {
    if (data) {
      toast.dark(data.sucesso, {
        type: "success",
      });
      setTimeout(() => {
        history.goBack();
      }, 1000);
    }
  }, [data, history]);

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ my: 1, p: 1 }}>
        <EntradaForm
          schema={schema}
          onSubmit={onSubmit}
          schemaValidator={schemaValidator}
          schemaMessageError={schemaMessageError}
          wait={wait}
        />
      </Paper>
    </Container>
  );
};
